<script lang="ts">
  import { fade } from 'svelte/transition';
  import BaseModule from '$src/js/base/BaseModule';
  import type { NewsletterApiResponse } from './newsletter.d';

  let { large = false }: { large?: boolean } = $props();

  let email = $state('');
  let status = $state<'idle' | 'forminvalid' | 'loading' | 'success' | 'error'>('idle');
  let message = $state('');

  const validateEmail = (email: string) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };

  const handleSubmit = async (event: Event) => {
    event.preventDefault();

    if (!email || !validateEmail(email)) {
      status = 'forminvalid';
      message = BaseModule.getInstance().i18n.translate('newsletter_email_invalid');
      return;
    }

    if (status === 'loading') return;

    status = 'loading';

    const formData = new FormData();
    formData.append('email', email);

    try {
      const response = await fetch('/api-simple/?module=newsletter&action=subscribe', {
        method: 'POST',
        body: formData,
        headers: {
          Accept: 'application/json',
        },
      });

      const data = (await response.json()) as NewsletterApiResponse;

      if (data.status === 'success' || response.ok) {
        status = 'success';
        message = BaseModule.getInstance().i18n.translate('newsletter_success');
        email = '';
      } else {
        status = 'error';
        message = BaseModule.getInstance().i18n.translate('newsletter_error');
      }
    } catch {
      status = 'error';
      message = BaseModule.getInstance().i18n.translate('newsletter_error');
    }
  };
</script>

{#if status === 'success' || status === 'error'}
  <div
    class="text-14asrem leading-[150%]"
    in:fade={{ duration: 300, delay: 300 }}
    out:fade={{ duration: 300 }}
  >
    {message}
  </div>
{:else}
  <form
    class="border-stroke-neutral-def-primary flex items-center border"
    novalidate
    onsubmit={handleSubmit}
    in:fade={{ duration: 300, delay: 300 }}
    out:fade={{ duration: 300 }}
  >
    <input
      class="flex-1 p-4 {large ? 'text-18asrem h-12 sm:h-16' : 'h-12'}"
      name="email"
      type="email"
      bind:value={email}
      placeholder={BaseModule.getInstance().i18n.translate('newsletter_email_placeholder')}
      disabled={status === 'loading'}
    />

    <button
      class="btn-icon btn-icon--filled {large ? 'sm:h-16! sm:w-16!' : 'btn-icon btn-icon--filled'}"
      type="submit"
      disabled={status === 'loading'}
      aria-label="Subscribe"
    >
      <svg class={large ? 'sm:h-6 sm:w-6' : ''} width="18" height="18" aria-hidden="true">
        <use xlink:href="/dist/svg-sprite/sprite.svg?v=11#paper-plane"></use>
      </svg>
    </button>
  </form>

  {#if status === 'forminvalid'}
    <div class="text-14asrem mt-2 leading-[150%]">
      {message}
    </div>
  {/if}
{/if}
